import React, { useEffect } from "react";
import "./ScrollImg.css";

import s1 from "../../Assets/project7/s1.webp";
import s2 from "../../Assets/project7/s2.webp";
import s3 from "../../Assets/project7/s3.webp";
import s4 from "../../Assets/project7/s4.webp";
import s5 from "../../Assets/project7/s5.webp";
import s6 from "../../Assets/project7/s6.webp";
import s7 from "../../Assets/project7/s7.webp";
import s8 from "../../Assets/project7/s8.webp";
import s9 from "../../Assets/project7/s9.webp";
import s10 from "../../Assets/project7/s10.webp";
import s11 from "../../Assets/project7/s11.webp";
import s12 from "../../Assets/project7/s12.webp";
import s13 from "../../Assets/project7/s13.webp";
import s14 from "../../Assets/project7/s14.webp";
import s15 from "../../Assets/project7/s15.webp";
import s16 from "../../Assets/project7/s16.webp";
import s17 from "../../Assets/project7/s17.webp";
import s18 from "../../Assets/project7/s18.webp";
import s19 from "../../Assets/project7/s19.webp";
import s20 from "../../Assets/project7/s20.webp";
import s21 from "../../Assets/project7/s21.webp";
import s22 from "../../Assets/project7/s22.webp";
import s23 from "../../Assets/project7/s23.webp";
import s24 from "../../Assets/project7/s24.webp";
import s25 from "../../Assets/project7/s25.webp";
import s26 from "../../Assets/project7/s26.webp";
import s27 from "../../Assets/project7/s27.webp";
import s28 from "../../Assets/project7/s28.webp";
import s29 from "../../Assets/project7/s29.webp";
import s30 from "../../Assets/project7/s30.webp";
import s31 from "../../Assets/project7/s31.webp";
import s32 from "../../Assets/project7/s32.webp";
import s33 from "../../Assets/project7/s33.webp";
import s34 from "../../Assets/project7/s34.webp";
import s35 from "../../Assets/project7/s35.webp";
import s36 from "../../Assets/project7/s36.webp";
import s37 from "../../Assets/project7/s37.webp";
import s38 from "../../Assets/project7/s38.webp";
import s39 from "../../Assets/project7/s39.webp";
import s40 from "../../Assets/project7/s40.webp";
import s41 from "../../Assets/project7/s41.webp";

const ScrollImg7 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scroll = window.scrollY + window.innerHeight / 3;

      let isActiveSectionFound = false;

      sections.forEach((section) => {
        const top = section.offsetTop;
        const height = section.offsetHeight;

        if (top <= scroll && top + height > scroll) {
          sections.forEach((s) => s.classList.remove("active"));
          section.classList.add("active");
          isActiveSectionFound = true;
        }
      });

      // If no section is in view, ensure all are inactive
      if (!isActiveSectionFound) {
        sections.forEach((s) => s.classList.remove("active"));
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll effect initially
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const images = [
    s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17,
    s18, s19, s20, s21, s22, s23, s24, s25, s26, s27, s28, s29, s30, s31, s32,
    s33, s34, s35, s36, s37, s38, s39, s40, s41,
  ];

  return (
    <div>
      {images.map((image, index) => (
        <div key={index} className="section">
          <div className="section-img">
            <div
              className="section-img-inner"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScrollImg7;
